// extracted by mini-css-extract-plugin
module.exports = {"modalContainer":"DeleteProfile_modalContainer__So3ot","deleteTextTitle":"DeleteProfile_deleteTextTitle__Wp7NZ","deleteText":"DeleteProfile_deleteText__tXMx1"};